import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { NachaService } from '../nacha.service';
import { NachaStepsDialogComponent } from '../nacha-steps-dialog/nacha-steps-dialog.component';

@Component({
    selector: 'app-tax-preview-dialog',
    templateUrl: './tax-preview-dialog.component.html',
    styleUrls: ['./tax-preview-dialog.component.css'],
    standalone: false
})
export class TaxPreviewDialogComponent implements OnInit {

    loading = true;
    rows: any[] = [];
    error: string | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { ownerStmtIds: number[] },
        private dialogRef: MatDialogRef<TaxPreviewDialogComponent>,
        private nachaService: NachaService,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.nachaService.getTaxPreview(this.data.ownerStmtIds).subscribe({
            next: (rows) => {
                this.rows = rows;
                this.loading = false;
            },
            error: (err) => {
                this.error = 'Failed to load tax preview.';
                this.loading = false;
                console.error(err);
            }
        });
    }

    allBatched(taxType: 'GET' | 'TAT' | 'MCTAT'): boolean {
        const relevant = this.rows.filter(r => this.getAmount(r, taxType) > 0);
        if (relevant.length === 0) return true;
        return relevant.every(r => this.getBatchId(r, taxType) != null);
    }

    getAmount(row: any, taxType: string): number {
        switch (taxType) {
            case 'GET':   return row.getAmount   ?? 0;
            case 'TAT':   return row.tatAmount   ?? 0;
            case 'MCTAT': return row.mctatAmount ?? 0;
            default:      return 0;
        }
    }

    getBatchId(row: any, taxType: string): number | null {
        switch (taxType) {
            case 'GET':   return row.getNachaBatchId   ?? null;
            case 'TAT':   return row.tatNachaBatchId   ?? null;
            case 'MCTAT': return row.mctatNachaBatchId ?? null;
            default:      return null;
        }
    }

    openNachaSteps(taxType: 'GET' | 'TAT' | 'MCTAT'): void {
        const eligible = this.rows.filter(r => this.getAmount(r, taxType) > 0);
        const cfg = new MatDialogConfig();
        cfg.maxWidth = '80vw';
        cfg.width = '700px';
        cfg.disableClose = false;
        cfg.data = {
            ownerStmtIds: eligible.map(r => r.ownerStmtId),
            taxType,
            previewRows: eligible
        };
        const ref = this.dialog.open(NachaStepsDialogComponent, cfg);
        ref.afterClosed().subscribe(() => {
            // Refresh preview after NACHA steps dialog closes (batch IDs may have changed)
            this.loading = true;
            this.ngOnInit();
        });
    }

    getTotalTax(row: any): number {
        return (row.getAmount ?? 0) + (row.tatAmount ?? 0) + (row.mctatAmount ?? 0);
    }

    close(): void {
        this.dialogRef.close();
    }
}
